<template>
  <v-container>
    <v-row>
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <div>
            <div class="header_title">
              <v-row class="ma-3 header_title" no-gutters>
                <v-col class="pt-6" cols="12" md="2">
                  Support Team
                  <br/>
                  <br/>
                </v-col>

                <v-col cols="12" md="10">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="3"></v-col>
                    <v-col class="text-right" cols="12" md="2" sm="1">
                      <v-btn
                          class="green-color"
                          dark
                          height="38"
                          width="100%"
                          @click="addMember"
                      >
                        Add Member
                        <v-icon dark right>mdi-plus-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div
                class="md-content md-table md-theme-default table_borders"
                table-header-color="orange"
                value
            >
              <div
                  class="
                  md-content md-table-content md-scrollbar md-theme-default
                "
              >
                <table>
                  <thead class="md-card-header">
                  <tr>
                    <th class="md-table-head">
                      <div
                          class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">Name</div>
                      </div>
                    </th>

                    <th class="md-table-head">
                      <div
                          class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">Email</div>
                      </div>
                    </th>
                    <th class="md-table-head">
                      <div
                          class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">Action</div>
                      </div>
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr
                      v-for="(data, index) in members"
                      :key="data.id"
                      class="md-table-row"
                  >
                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{ data.first_name }} {{ data.last_name }}
                      </div>
                    </td>
                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{ data.email ? data.email : "NA" }}
                      </div>
                    </td>

                    <td class="md-table-cell" style="min-width: 120px">
                      <v-btn
                          :color="data.status_id == 1 ? 'Active' : 'Inactive'"
                          class="d-inline-block text-truncate"
                          dark
                          fab
                          x-small
                          @click="changeMemberStatus(data.id, index)"
                      >
                        <v-icon dark>{{
                            data.status_id == 1
                                ? "mdi-lock-open-variant"
                                : "mdi-lock"
                          }}
                        </v-icon>
                      </v-btn
                      >

                      <v-btn
                          class="d-inline-block text-truncate"
                          color="#00b0af"
                          dark
                          fab
                          x-small
                          @click="editMember(data)"
                      >
                        <v-icon dark>mdi-pencil</v-icon>
                      </v-btn
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <v-pagination
                v-model="page"
                :length="totalPages"
                :page="page"
                total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-row>
    <v-dialog
        v-model="addMemberModel"
        v-resize="onResize"
        max-width="50%"
        persistent
        scrollable
    >
      <v-card ref="card">
        <v-card-title class="headline"
        >{{ editFlag ? "Update" : "Add" }} Member
        </v-card-title
        >
        <v-card-text class="form_bg">
          <v-container>
            <v-form ref="form" v-model="valid" v-on:submit.prevent>
              <v-row>
                <v-col md="12">
                  <v-row class="ma-1">
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="memberForm.first_name"
                          :rules="[(v) => !!v || 'First Name is required']"
                          background-color="#fff"
                          label="First Name*"
                          outlined
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="memberForm.last_name"
                          :rules="[(v) => !!v || 'Last Name is required']"
                          background-color="#fff"
                          label="Last Name*"
                          outlined
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="memberForm.email"
                          :rules="[
                            (v) => !!v || 'E-mail is required',
                            (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                          ]"
                          background-color="#fff"
                          label="E-mail*"
                          outlined
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="memberForm.password"
                          :label="`Password${memberForm.id?'':'*'}`"
                          :required="!memberForm.id"
                          :rules="memberForm.id?[]:[(v) => !!v || 'Password is required']"
                          background-color="#fff"
                          outlined
                          type="password"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="ma-2 white--text green-color" text @click="cancelForm"
          >Close
          </v-btn
          >
          <v-btn
              class="ma-2 white--text blue-color"
              text
              @click="addUpdatePartner"
          >{{ editFlag ? "Update" : "Add" }} Member
          </v-btn
          >

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      addMemberModel: false,
      members: [],
      memberForm: {},
      page: 1,
      totalPages: 1,
      show2: false,
      valid: true,
      editFlag: false,
      member: {},
    };
  },
  mounted() {
    this.getMembers();
  },
  computed: {},
  watch: {
    page() {
      this.getMembers();
    },
  },
  methods: {
    getMembers() {
      let url = "support/members?per_page=10&page=" + this.page;
      this.$http
          .get(url)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.members = response.data.data.data;
              this.totalPages = Math.ceil(response.data.data.total / response.data.data.per_page);
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    downloadPem(file) {
      console.log(file)
      window.open(process.env.VUE_APP_S3_BUCKET_URL + file);
    },
    addMember() {
      this.memberForm = {};
      this.addMemberModel = true;
      setTimeout(() => {
        this.onResize();
      }, 10);
    },
    addUpdatePartner(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }

      let formData = new FormData();
      formData.set("first_name", this.memberForm.first_name);
      formData.set("last_name", this.memberForm.last_name);
      formData.set("email", this.memberForm.email);
      if (this.memberForm.password) {
        formData.set("password", this.memberForm.password);
      }
      if (this.memberForm.id) {
        formData.set("id", this.memberForm.id);
      }
      this.$http({
        url: "support/members",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
          .then((response) => {
            if (response.status == 200) {
              this.addMemberModel = false;
              if (this.memberForm.id)
                this.showSuccess("Member Updated Successfully.");
              else this.showSuccess("Member Added Successfully.");
              this.getMembers();
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    changeMemberStatus(id, index) {
      this.$http
          .put(`support/member/${id}/status`)
          .then((response) => {
            if (response.status == 200) {
              let status = response.data.data.status_id;
              this.members[index].status_id = status;
              this.showSuccess(
                  `Member ${
                      status == 1 ? "activated" : "deactivated"
                  } successfully`
              );
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    editMember(data) {
      if (typeof data.id != "undefined") {
        this.editFlag = true;
        this.memberForm = {...data};
        this.addMemberModel = true;
        setTimeout(() => {
          this.onResize();
        }, 10);
      }
    },
    cancelForm() {
      this.$refs.form.resetValidation();
      this.addMemberModel = false;
      this.memberForm = {};
      this.editFlag = false;
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
  },
};
</script>
<style scoped>
.validation-message {
  color: red;
  font-size: 12px;
}

.md-card {
  margin: 0 0 25px 0;
}

.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
</style>
